import React from 'react';
import {
  Row, Col,
} from 'antd';
import { useTranslation } from 'react-i18next';
import {
  WelcomeLabel, RegistrationHeader,
} from '../Forms';
import CustomTrans from '../CustomTrans';

const RegisterAccountHeader = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col span={24}>
          <Row
            type="flex"
            style={{ alignItems: 'center', marginTop: '10px' }}
            justify="center"
            gutter={10}
          >
            <WelcomeLabel>{t('FORM_USER_ACCOUNT.WELCOME_HEADER')}</WelcomeLabel>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={2} />
        <Col span={2} />
        <Col span={16}>
          <Row
            type="flex"
            style={{ alignItems: 'center', marginTop: '-15px' }}
            justify="center"
            gutter={10}
          >
            <RegistrationHeader>
              <CustomTrans label="FORM_USER_ACCOUNT.REGISTER_USER_ACCOUNT_HEADER" />
            </RegistrationHeader>
          </Row>
        </Col>
        <Col span={4} />
      </Row>
    </>
  );
};

export default RegisterAccountHeader;

RegisterAccountHeader.propTypes = {
};
